import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SlicePipe } from '@angular/common';
import {
  ImmomioDropdown,
  ImmomioDropdownTrigger,
  ImmomioDropdownMenu
} from '@immomio/ui/dropdown';
import { BadgeComponent } from '../../atoms/badge/badge.component';
import { WbsTagComponent } from '../wbs-tag/wbs-tag.component';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImmomioDropdown,
    ImmomioDropdownTrigger,
    ImmomioDropdownMenu,
    BadgeComponent,
    SlicePipe,
    WbsTagComponent
  ]
})
export class TagListComponent {
  readonly tags = input<string[]>(undefined);
  readonly amountBeforeTruncation = input(2);
  readonly truncateLabels = input(true);
  readonly readonly = input(false);
  readonly enableUpperCase = input(true);
}
